import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/:product_number?',
    name: 'Home',
    component: () => import('@/views/Home'),
  },
  {
    path: '/page/:product_number/:id?',
    name: 'Page',
    component: () => import('@/views/Page'),
  },
]

export default new Router({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})
